import Vue from 'vue'
import VCalendar from 'v-calendar'
import 'v-calendar/src/styles/base.css'

Vue.use(VCalendar)
